module.exports = __webpack_public_path__ + "img/reset-tip.6658f6f5.png";